<template>
  <b-modal v-if="showModal" v-model="showModal" button-size="sm" size="lg" title="Images"
           :centered="true" footer-class="p-2 border-top-0" header-class="p-2 border-bottom-0"
           header-bg-variant="primary" header-text-variant="white" header-close-variant="white"
           :hide-header-close="true" :no-close-on-backdrop="true" :no-close-on-esc="true">
    <div v-if="isLoading" class="text-center text-success my-2">
      <b-spinner class="align-middle mr-2" size="lg"></b-spinner>
      <strong>Loading...</strong>
    </div>
    <div v-else class="d-flex flex-wrap  justify-content-center" style="gap: 10px;">
      <a v-for="image in images" :href="`/api/actions/${actionId}/images/${image}`" target="_blank">
        <img :src="`/api/actions/${actionId}/images/${image}`" style="width: 200px;">
      </a>
    </div>
    <template #modal-footer>
      <b-button variant="secondary" size="sm" @click="close()">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import apiRequest from '../../JS/api-request';
  import { format, parseISO } from 'date-fns';
  import { BModal, BSpinner, BCard, BButton } from 'bootstrap-vue';

  export default {
    name: 'RecommendationImages',
    components: { BSpinner, BCard, BModal, BButton },
    data: function () {
      return {
        images: [],
        showModal: false,
        isLoading: true,
      }
    },
    watch: {
      show(val) {
        if (val) {
          this.load();
        }

        this.showModal = val;
      }
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      actionId: {
        type: Number,
        default: 0
      },
      customerId: {
        type: String,
        default: ''
      },
      siteId: {
        type: Number,
        default: 0
      }
    },
    methods: {
      load() {
        apiRequest({
          method: 'get',
          url: `/api/actions/${this.actionId}/images`,
          busyFunc: x => this.isLoading = x,
          successFunc: x => {
            this.images = x
          },
          errorMsg: 'There was an error loading images',
          toaster: this.$bvToast
        });
      },
      close() {
        this.$emit('hide', null);
      }
    }
  }
</script>
